import { IListItem, IReferralConfig } from '@nkr/models/index';
import { IValidation } from './validation';
import { Col, ControlLabel, FormControl, FormGroup, Panel, Radio } from 'react-bootstrap';

interface IProps {
    data: IReferralConfig,
    validation: IValidation,
    dirty: boolean,
    statusList: IListItem[],
    onRadioChange: (e: React.FormEvent<Radio & HTMLInputElement>) => void,
    onDataChange: (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => void
}

const Workflow = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Workflow » Organize Donors</div>
                    <FormGroup style={{ margin: 0 }} validationState={props.dirty && !props.validation.intakeWorkflowConfig ? 'error' : null}>
                        <Radio inline id='intakeWorkflowConfig' name='intakeWorkflowConfig' value={0} checked={props.data.intakeWorkflowConfig == 0} style={{ paddingTop: 0 }} onChange={props.onRadioChange}>by Contact</Radio>
                        <Radio inline id='intakeWorkflowConfig' name='intakeWorkflowConfig' value={1} checked={props.data.intakeWorkflowConfig == 1} style={{ paddingTop: 0 }} onChange={props.onRadioChange}>by EMR</Radio>
                    </FormGroup>
                </div>
            </Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={props.dirty && !props.validation.mustAcceptBloodTransfusions ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Require donor to accept blood transfusions?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='mustAcceptBloodTransfusions' value={1} checked={props.data.mustAcceptBloodTransfusions != null ? props.data.mustAcceptBloodTransfusions : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='mustAcceptBloodTransfusions' value={0} checked={props.data.mustAcceptBloodTransfusions != null ? !props.data.mustAcceptBloodTransfusions : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.requireQuitTobacco ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Must quit smoking prior to surgery?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='requireQuitTobacco' value={1} checked={props.data.requireQuitTobacco != null ? props.data.requireQuitTobacco : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='requireQuitTobacco' value={0} checked={props.data.requireQuitTobacco != null ? !props.data.requireQuitTobacco : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.ruleOutOnGestationalDiabetes ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on gestational diabetes?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='ruleOutOnGestationalDiabetes' value={1} checked={props.data.ruleOutOnGestationalDiabetes != null ? props.data.ruleOutOnGestationalDiabetes : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='ruleOutOnGestationalDiabetes' value={0} checked={props.data.ruleOutOnGestationalDiabetes != null ? !props.data.ruleOutOnGestationalDiabetes : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.ruleOutOnHiv ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on HIV?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='ruleOutOnHiv' value={1} checked={props.data.ruleOutOnHiv != null ? props.data.ruleOutOnHiv : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='ruleOutOnHiv' value={0} checked={props.data.ruleOutOnHiv != null ? !props.data.ruleOutOnHiv : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.alwaysRuleOutOnHeartAttack ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on heart attack?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='alwaysRuleOutOnHeartAttack' value={1} checked={props.data.alwaysRuleOutOnHeartAttack != null ? props.data.alwaysRuleOutOnHeartAttack : false} onChange={props.onRadioChange}>Always</Radio>
                        <Radio inline name='alwaysRuleOutOnHeartAttack' value={0} checked={props.data.alwaysRuleOutOnHeartAttack != null ? !props.data.alwaysRuleOutOnHeartAttack : false} onChange={props.onRadioChange}>Until <span className='label label-info'>x</span> Years</Radio>
                    </Col>
                </FormGroup>

                {props.data.alwaysRuleOutOnHeartAttack == false && (
                    <FormGroup validationState={props.dirty && !props.validation.heartAttackRemissionRequired ? 'error' : null}>
                        <Col xs={12} lg={6} componentClass={ControlLabel}>How many years required since last heart attack?</Col>
                        <Col xs={12} lg={5}>
                            <FormControl
                                componentClass='select'
                                name='heartAttackRemissionRequired'
                                id="heartAttackRemissionRequired"
                                value={props.data.heartAttackRemissionRequired}
                                onChange={props.onDataChange}
                            >
                                {props.statusList.map(i =>
                                    <option key={'expDays-' + i.id} value={i.id}>{i.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>
                )}

                <FormGroup validationState={props.dirty && !props.validation.ruleOutOnPregnancy ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Temporary (soft) rule out on pregnancy?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='ruleOutOnPregnancy' value={1} checked={props.data.ruleOutOnPregnancy != null ? props.data.ruleOutOnPregnancy : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='ruleOutOnPregnancy' value={0} checked={props.data.ruleOutOnPregnancy != null ? !props.data.ruleOutOnPregnancy : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                {props.data.ruleOutOnPregnancy && (
                    <>
                        <FormGroup validationState={props.dirty && !props.validation.ruleOutOnPregnancyWaitTime ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>How many months after pregnancy does donor candidate need to wait?</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    type="text"
                                    id="ruleOutOnPregnancyWaitTime"
                                    style={{ width: 300 }}
                                    value={props.data.ruleOutOnPregnancyWaitTime}
                                    onChange={props.onDataChange}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.ruleOutOnNursing ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on Nursing?</Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='ruleOutOnNursing' value={1} checked={props.data.ruleOutOnNursing != null ? props.data.ruleOutOnNursing : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='ruleOutOnNursing' value={0} checked={props.data.ruleOutOnNursing != null ? !props.data.ruleOutOnNursing : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>
                    </>
                )}

                <FormGroup validationState={props.dirty && !props.validation.minAgeNdd ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Min Age for Non-Directed Donor?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="minAgeNdd"
                            placeholder='0 to 255'
                            style={{ width: 300 }}
                            value={props.data.minAgeNdd}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.minAgeDd ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Min Age for Directed Donor?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="minAgeDd"
                            placeholder='0 to 255'
                            style={{ width: 300 }}
                            value={props.data.minAgeDd}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default Workflow;